import { Box, ListItemAvatar, Typography, useTheme } from '@mui/material';
import { ReactNode, useMemo } from 'react';

import { AddressModel } from '@common-lib';

import { type PortalTheme } from '../../theme';
import { ListItemCard } from '../list-item-card.component';

export interface SiteUnitListCardProps {
  id: string;
  displayName: string;
  isLoggedIn: boolean;
  descriptionVisibility?: 'show' | 'hide';
  addressVisibility?: 'streetCity' | 'hide';
  thumbnailVisibility?: 'show' | 'hide';
  description?: string;
  ariaLabel?: string;
  address?: AddressModel | undefined;
  thumbnail?: ReactNode | undefined;
  onClick: () => void;
  favoriteComponent?: () => React.ReactNode;
}

export const SiteUnitListCard = (props: SiteUnitListCardProps) => {
  const theme = useTheme<PortalTheme>();

  const formattedAddress = useMemo(() => {
    return AddressModel.formatAddress(props.address);
  }, [props?.address]);

  return (
    <ListItemCard
      primaryText={
        <Typography variant="subtitle1">{props.displayName}</Typography>
      }
      secondaryText={
        props.descriptionVisibility === 'show' ? props.description : undefined
      }
      tertiaryText={
        props.addressVisibility === 'streetCity' && formattedAddress
          ? formattedAddress
          : undefined
      }
      onClick={props.onClick}
      startAdornment={
        props.thumbnail &&
        props.thumbnailVisibility === 'show' && (
          <Box sx={{ marginBottom: 'auto' }}>
            <ListItemAvatar>
              <>
                {props.thumbnail && (
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      marginRight: 1,
                      borderRadius: '4px',
                      overflow: 'hidden',
                    }}
                  >
                    {props.thumbnail}
                  </Box>
                )}
              </>
            </ListItemAvatar>
          </Box>
        )
      }
      endAdornment={
        props.isLoggedIn &&
        props.favoriteComponent && (
          <Box
            sx={{
              position: 'relative',
              width: theme.spacing(2),
              height: theme.spacing(2),
              top: theme.spacing(-1),
              right: theme.spacing(1.75),
            }}
          >
            {props.favoriteComponent()}
          </Box>
        )
      }
      cancelHoverOnEndAdornment={props.isLoggedIn}
      ariaLabel={props.ariaLabel}
    />
  );
};
